'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconUserHelmetSafety, iconUserHelmetSafetyTag } from '@ni/nimble-components/dist/esm/icons/user-helmet-safety';
import { wrap } from '../../utilities/react-wrapper';

export type { IconUserHelmetSafety };
export { iconUserHelmetSafetyTag };
export const NimbleIconUserHelmetSafety = wrap(IconUserHelmetSafety);